
var winW = $(window).width();

$(window).on('load', function() {
    var SiteTitleTop = $("#site_title").offset().top;
    var introTranslatePC = -(SiteTitleTop - 260);
    var introTranslateSP = -(SiteTitleTop - 210);

        var date=new Date();
        date.setTime(date.getTime() + (60*60*1000));
        // 1回目のアクセス
        if ($.cookie("intro_access") == undefined) {
            //最初にアクセスしたときにはここに書いたアニメーションのJSが動く
            $.cookie('intro_access', 'on', { expires: date,path: '/' });
                $("html ,body").css({ overflow: "hidden"});
                $(window).on('touchmove.noScroll', function(e) {
                e.preventDefault();
            });

            $('#intro').css({ opacity: "1" });

            setInterval(function() {

                if (winW >= 768) {

                $("#intro").animate({ 'marginTop': introTranslatePC + 'px'},1000, 'swing');

                } else {

                $("#intro").animate({ 'marginTop': introTranslateSP + 'px'},1000, 'swing');
                }
            }, 2500);

            setInterval(function() {
                $('#intro').addClass('complate');

            }, 1000);

            setInterval(function() {
                $(".intro_bg").animate({ opacity: "0" });
                $('.intro_bg').remove();
                $("#intro").remove();
                if (winW <= 767) {
                    $("#top_header").css({ padding: "210px 0 170px" });
                } else {
                    $("#top_header").css({ padding: "260px 0" });
                }
                $("html, body").css({ overflow: ""});
                $(window).off('.noScroll');
            }, 3500);

        
        } else {
            $("html, body").css({ overflow: ""});
            $(window).off('.noScroll');
            $('.intro_bg').remove();
            $("#intro").remove();
            if (winW <= 767) {
                $("#top_header").css({ padding: "210px 0 170px" });
            } else {
                $("#top_header").css({ padding: "260px 0" });
            }
        }
});

var windowScroll = $(window).scrollTop();
scrollHeight = $(document).height(), //ドキュメントの高さ
    windowHeight = $(window).height(), //ウィンドウの高さ
    pageBottom = scrollHeight - windowHeight; //ドキュメントの高さ - ウィンドウの高さ
$(window).scroll(function() {

    var scroll = $(this).scrollTop();
    var TopVisialTop = $(".top_visual").offset().top;
    if (scroll >= TopVisialTop) {
        $("#header").addClass('header--hidden');
        if (scroll < windowScroll && scroll > 100) {
            $("#header").addClass('header--visible');
            $("#header").removeClass('header--hidden');
            $("#header .title_logo").css('display', 'block');
        } else if ($('body').hasClass('nav_open')) {
            $("#header").removeClass('header--hidden');
            $("#header").addClass('header--visible');
        } else {
            $("#header").removeClass('header--visible');
            $("#header").addClass('header--hidden');
        }
    } else if (pageBottom <= windowScroll) {
        $("#header").addClass('header--hidden');
        $("#header").removeClass('header--visible');
    } else {
        $("#header").removeClass('header--hidden');
        $("#header .title_logo").css('display', 'none');
    }

    windowScroll = scroll;
});